import { useState, useEffect } from "react";

const navLinks = [
  { label: "Inicio", href: "#inicio" },
  { label: "Sobre mí", href: "#sobre-mi" },
  { label: "Servicios", href: "#servicios" },
  { label: "Preguntas frecuentes", href: "#preguntas-frecuentes" },
  { label: "Testimonios", href: "#testimonios" },
  { label: "Contacto", href: "#contacto" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleNav = (href: string) => {
    setMenuOpen(false);
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <nav
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-500 ${
        scrolled ? "bg-[#fdf9f3]/95 backdrop-blur-md shadow-sm" : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 flex items-center justify-between h-20">
        {/* Logo */}
        <a
          href="#inicio"
          onClick={(e) => { e.preventDefault(); handleNav("#inicio"); }}
          className="flex items-center gap-3 cursor-pointer"
        >
          <img
            src="https://static.readdy.ai/image/9d8cfb7979fc745e2d4072c466ad6183/536a20549f5172b8a6a9120f71db9d15.jpeg"
            alt="Celeste Tarot Logo"
            className="w-10 h-10 rounded-full object-cover"
          />
          <span className="font-semibold text-lg tracking-wide whitespace-nowrap" style={{ fontFamily: "'Cormorant Garamond', serif", color: scrolled ? "#7a5c2e" : "#C9A84C" }}>
            Celeste Tarot
          </span>
        </a>

        {/* Desktop Nav */}
        <ul className="hidden md:flex items-center gap-7">
          {navLinks.map((link) => (
            <li key={link.href}>
              <a
                href={link.href}
                onClick={(e) => { e.preventDefault(); handleNav(link.href); }}
                className="text-sm tracking-wide transition-colors duration-200 cursor-pointer whitespace-nowrap hover:text-[#C9A84C]"
                style={{ color: scrolled ? "#5a4a35" : "#f5ede0" }}
              >
                {link.label}
              </a>
            </li>
          ))}
          <li>
            <a
              href="#contacto"
              onClick={(e) => { e.preventDefault(); handleNav("#contacto"); }}
              className="bg-[#C9A84C] text-white px-5 py-2 rounded-full text-sm font-semibold hover:bg-[#b8943e] transition-colors duration-200 cursor-pointer whitespace-nowrap"
            >
              Reservar
            </a>
          </li>
        </ul>

        {/* Mobile Hamburger */}
        <button
          className="md:hidden w-8 h-8 flex items-center justify-center cursor-pointer"
          style={{ color: scrolled ? "#C9A84C" : "#C9A84C" }}
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Abrir menú"
        >
          <i className={`text-xl ${menuOpen ? "ri-close-line" : "ri-menu-line"}`}></i>
        </button>
      </div>

      {/* Mobile Menu */}
      {menuOpen && (
        <div className="md:hidden bg-[#fdf9f3]/98 backdrop-blur-md px-6 pb-6 pt-2 border-t border-[#e8dcc8]">
          <ul className="flex flex-col gap-4">
            {navLinks.map((link) => (
              <li key={link.href}>
                <a
                  href={link.href}
                  onClick={(e) => { e.preventDefault(); handleNav(link.href); }}
                  className="text-[#5a4a35] hover:text-[#C9A84C] text-base tracking-wide transition-colors duration-200 cursor-pointer block"
                >
                  {link.label}
                </a>
              </li>
            ))}
            <li>
              <a
                href="#contacto"
                onClick={(e) => { e.preventDefault(); handleNav("#contacto"); }}
                className="bg-[#C9A84C] text-white px-5 py-2 rounded-full text-sm font-semibold hover:bg-[#b8943e] transition-colors duration-200 cursor-pointer whitespace-nowrap inline-block"
              >
                Reservar sesión
              </a>
            </li>
          </ul>
        </div>
      )}
    </nav>
  );
}
